import { post,fetch } from '../service/http-service';
import API from "../service/config";


const getDefaultState = (): any => {
  return {
    steps: [],
    currentStep: {},
    analysisResult: {},
    staticSteps: false,
    cellTree: [],
    organTree: {},
    nodes_arr: null
  };
};

const state: any = getDefaultState();

const mutations = {
  RESET_STATE(state: any) {
    Object.assign(state, getDefaultState());
  },
  CELL_TREE(state: any, cellTree: []) {
    state.cellTree = cellTree;
  },

};

const actions = {
  async fetchCelltree({ commit, state }: { commit: any; state: any }) {
    if (state.cellTree.length > 0) {
      return state.cellTree;
    }
    let postData: any = {
        fileName: "celltypetree.csv",
        };
      const result:any = await post(API.domainUrl + API.readCsv, postData).then((response: any) => {
        return response.data;
      })
      const parentnode = result.Parent;
      const celltyps = result["Cell type"];
      let chartData = celltyps.map((item: string, i: number) => {
        return { label: item, parent: parentnode[i] };
      });
      const parentFn = (pNode: any) => {
        pNode.children = chartData
          .map((cell: any) => {
            if (cell.parent == pNode.label) {
              return { label: cell.label, children: [] };
            }
          })
          .filter((val: any) => val);
  
        if (pNode.children.length > 0) {
          pNode.children.forEach((node: any) => {
            if (node.label == "Fibroblast" && pNode.label == "Fibroblast") return;
            parentFn(node);
          });
        } else {
        }
      };
      let nodes = { label: "Cell", children: [] };
      parentFn(nodes);
  
      commit("CELL_TREE", [nodes]);
      return [nodes];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};